import { StateProvider, StateService } from "@uirouter/angularjs";
import { IServiceProvider } from "angular";
import { UserProfile } from "../../application/UserProfile";
import { AuthorizedUiElementConfig } from "./authorizedUiElementConfig";
import { AuthorizedUiElementService } from "./authorizedUiElementService";

export abstract class AuthorizedUiElementServiceProvider<
  TAuthorizedUiElementConfig extends AuthorizedUiElementConfig
> implements IServiceProvider
{
  static $inject = ["$stateProvider"];

  abstract $get: any;
  abstract basePath: string;

  readonly elementConfigs: TAuthorizedUiElementConfig[] = [];

  constructor(private readonly $stateProvider: StateProvider) {}

  addElement(
    config: TAuthorizedUiElementConfig
  ): AuthorizedUiElementServiceProvider<TAuthorizedUiElementConfig> {
    this.elementConfigs.push(config);
    this.registerState(config, this.basePath);
    return this;
  }

  defaultServiceFactory(
    userProfile: UserProfile,
    $state: StateService
  ): AuthorizedUiElementService<TAuthorizedUiElementConfig> {
    return new AuthorizedUiElementService<TAuthorizedUiElementConfig>(
      userProfile,
      this.elementConfigs,
      $state,
      this.basePath
    );
  }

  private registerState(tab: AuthorizedUiElementConfig, parentPath: string) {
    if (!tab.stateDefinition) return;
    const path = `${parentPath}.${tab.uiSrefFragment}`;
    this.$stateProvider.state(path, tab.stateDefinition);
    tab.children?.forEach((c) => {
      this.registerState(c, path);
    });
  }
}
